import Swiper from 'swiper/bundle';




const build = () => {


    let swiper = new Swiper('.in-action .slider .swiper', {
        slidesPerView: 1,
        loop: true,
        speed: 400,
        pagination: {
            el: '.in-action .swiper-nav-wrapper .swiper-pagination',
            type: 'bullets',
        },
        navigation: {
            nextEl: '.in-action .swiper-nav-wrapper .swiper-button-next',
            prevEl: '.in-action .swiper-nav-wrapper .swiper-button-prev',
        },


    });


}





export default () => {
    build()
}